import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import Select from 'components/forms/Select';

import { resultsToOptions } from 'utils/misc';

import { getProducts } from 'redux/actions/productActions';

class ProductsFilter extends Component {
  static propTypes = {
    value: PropTypes.shape({}).isRequired,
    onChange: PropTypes.func.isRequired,
    products: PropTypes.shape({
      options: PropTypes.shape({}.isRequired),
    }).isRequired,
    getProducts: PropTypes.func.isRequired,
    accountId: PropTypes.number,
  }

  static defaultProps = {
    accountId: null,
  };

  handleLoadOptions = async (filterString) => {
    await this.props.getProducts({ accountId: this.props.accountId, search: filterString });
    const options = resultsToOptions(this.props.products.options, 'label', 'value');
    return options || [];
  }

  render() {
    const { value, onChange } = this.props;
    return (
      <Select
        isMulti
        placeholder="Products"
        value={value}
        onChange={onChange}
        cacheOptions
        defaultOptions
        loadOptions={this.handleLoadOptions}
      />
    );
  }
}

export default compose(connect(
  state => ({ products: state.products }),
  { getProducts },
))(ProductsFilter);
